(function( $ ){

    const parallax_scroll = () => {
        let scrollTop   = $(window).scrollTop();
        let height      = $(window).height();
        $( '.parallax' ).each( function(){
            let $container = $(this).closest('.parallax-container');
            if( $container.offset().top < scrollTop ){
                let y_offset    = (scrollTop - $container.offset().top) / height;
                let top_percent = 100 - (y_offset * 100);
                let min_percent = 100 * ($container.height() - $(this).height()) / $container.height();
                    top_percent = top_percent < min_percent ? min_percent : top_percent;
                $(this).css({top: top_percent + '%'});
            }
        });
    }

    $( window ).on( 'scroll', parallax_scroll );
    parallax_scroll();

})( jQuery );